import type { HistoryItem } from '../../api/event';
import tocCoin from '../../assets/ToC-Coin.png';
import styles from './ListItemHistory.module.css';

interface ListItemHistoryProps {
  item: HistoryItem;
}

function formatCoins(raw: number): string {
  return Math.round(raw / 100).toString();
}

export function ListItemHistory({ item }: ListItemHistoryProps) {
  const delta = item.change?.p1_delta?.delta ?? 0;
  const balance = item.change?.p1_delta?.balance;
  const isPositive = delta >= 0;
  const items = item.change?.items ?? [];

  let type = 'Non-Value Update';
  if (delta < 0) type = 'Purchase';
  else if (delta > 0) type = 'Recharge';

  const description = items.length > 0
    ? items.map(i => i.name).join(', ')
    : type;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.deviceInfo}>
          <span className={styles.deviceIcon}>📱</span>
          <span className={styles.deviceName}>{item.device}</span>
        </div>
        <span className={styles.date}>
          {new Date(item.datetime).toLocaleString(undefined, {
            dateStyle: 'medium',
            timeStyle: 'short',
          })}
        </span>
      </div>
      <div className={styles.body}>
        <span className={styles.description}>{description}</span>
        <div className={styles.amounts}>
          {delta !== 0 && (
            <span className={`${styles.delta} ${isPositive ? styles.positive : styles.negative}`}>
              {isPositive ? '+' : ''}{formatCoins(delta)}
              <img src={tocCoin} alt="coins" className={styles.coinIcon} />
            </span>
          )}
          {balance !== undefined && balance !== null && (
            <span className={styles.balance}>
              Balance: {formatCoins(balance)}
              <img src={tocCoin} alt="coins" className={styles.coinIcon} />
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default ListItemHistory;
